import React, { useEffect, useContext } from "react";
import { Button } from "semantic-ui-react";
import { AppContext } from "../../Context/AppContext";
import "./cmp-success.css";

export default function CMP_SUCCESS({
  set_mdl_open,
  var_modaltitle,
  var_message,
  success_function,
}) {
  const { defaultPane, OrderTabStatus } = useContext(AppContext);
  const [, set_default_pane] = defaultPane;
  const [orderStatus, setOrderStatus] = OrderTabStatus;

  /* VARIABLE DECLARATIONS
	---------------------------------------------------------------------------------*/

  /* EVENT LISTENERS
	---------------------------------------------------------------------------------*/
  useEffect(() => {}, []);

  /* EVENT FUNCTIONS
	---------------------------------------------------------------------------------*/

  /* RENDER APP
	---------------------------------------------------------------------------------*/
  return (
    <>
      <div className="modal-content">
        <div className="modal-success-title">
          <img src="/icon-success.svg" alt="" />
          {var_modaltitle}
        </div>
        <div className="modal-success-message">{var_message}</div>
        <div className="modal-goback-button">
          <Button
            color="red"
            onClick={() => {
              success_function();
              if (localStorage.getItem("impersonation")) {
                setOrderStatus("");
                set_default_pane(0);
              } else if (orderStatus === "followUp") {
                setOrderStatus("followUp");
                set_default_pane(2);
              } else if (orderStatus === "posted") {
                setOrderStatus("posted");
                set_default_pane(1);
              } else {
                setOrderStatus("");
                set_default_pane(0);
              }
            }}
          >
            Go Back
          </Button>
        </div>
      </div>
    </>
  );
}
